import React from 'react';
import liveChatFunction from './liveChatFunction/liveChatFunction';

export default function SpeedlyAnswer(props) {

  const prepareMesssageToSend = mess => {
    liveChatFunction.sendNewMessage(
      mess,
      props.state,
      props.dispatch,
      props.setNewMessage,
      props.setMessageLength,
      props.getActiveCom,
    );
  };

  return (
    <>
      <button
        className="fastAnswerBut"
        style={{'--newMesButBackground': 'lightgrey'}}
        onClick={() => prepareMesssageToSend('Oui')}>
          Oui
      </button>
      <button
        className="fastAnswerBut"
        style={{'--newMesButBackground': 'lightgrey'}}
        onClick={() => prepareMesssageToSend('Peut-être')}>
          Peut-être
      </button>
      <button
        className="fastAnswerBut"
        style={{'--newMesButBackground': 'lightgrey'}}
        onClick={() => prepareMesssageToSend('Non')}>
          Non
      </button>
      <button
        className="fastAnswerBut"
        style={{'--newMesButBackground': 'lightgrey'}}
        onClick={() => prepareMesssageToSend('Merci')}>
          Merci
      </button>
      <button
        className="fastAnswerBut"
        style={{'--newMesButBackground': 'lightgrey'}}
        onClick={() => prepareMesssageToSend('Un instant svp')}>
          Un instant svp
      </button>
    </>
  )
}
